import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, TextField } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { auth } from '../firebase'; // Import the Firebase authentication instance
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { storeTokenResponse } from '../tokenHandling';
import Snackbar from '@mui/material/Snackbar';
import { Link } from 'react-router-dom';
import axios from 'axios'; 

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const exchange_API_url = process.env.REACT_APP_EXCHANGE_API
  async function fetchdata(data) {
    try {
      const response = await axios.post( exchange_API_url, { code: data });
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  useEffect(() => {
    const fetchDataAsync = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const authorizationCode = searchParams.get('code');
      if (authorizationCode) {
        try {
          // Store or use the tokens as needed
          const response = await fetchdata(authorizationCode);
          storeTokenResponse(response.data); // Assuming response is an object with data property
        } catch (error) {
          console.error('Error storing token response:', error);
        }
      }
    };
    fetchDataAsync();

    // Check Firebase authentication status
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate('/home');
      }
    });

    return () => unsubscribe(); // Cleanup function
  }, [navigate, fetchdata]);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user; // Get the user from userCredential
      if (user) {
        console.log('User logged in successfully');
        navigate('/home'); // Redirect after successful login
      }
      // } else {
      //   console.error("Unverified e-mail");
      //   setErrorMessage("Unverified E-mail");
      //   setSnackbarOpen(true);
      // }
    } catch (error) {
      console.error('Error logging in:', error.message);
      setErrorMessage(error.message); // Set the error message
      setSnackbarOpen(true); // Open the Snackbar
    }
  };
  

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
        height: '80vh', // Full viewport height
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        key={'topcenter'}
        message={
          <Typography 
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              borderRadius: '20px',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          >
            {errorMessage}
          </Typography>
        }
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          width: '30%', // or fixed width, adjust as needed
          borderRadius: '20px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          padding: '50px',
        }}
      >
        <Card sx={{ borderRadius: '10px' }}>
          <CardMedia
            component="img"
            image="/logo.png"
            sx={{ width: 80, height: 80 }}
          />
        </Card>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Welcome to Droyd!
        </Typography>
        <TextField
          label="Email"
          variant="outlined"
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ width: '100%', backgroundColor: '#F5F5F5'}}
        />
        <TextField
          label="Password"
          variant="outlined"
          size="small"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ width: '100%', backgroundColor: '#F5F5F5'}}
        />
        <Button variant="contained" onClick={handleLogin} sx={{ backgroundColor: '#ff4c15ff', borderRadius:'10px', minWidth:"100px", minHeight:'50px' }}>
          Log in
        </Button>
        <Typography variant="body2" sx={{ marginTop: 2 }}>
          Don't have an account?{' '}
          <Link to="/signup" style={{ cursor: 'pointer' }}>
            Sign up
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default LoginPage;
